module.exports = __webpack_public_path__ + "img/icon8.ad220f62.png";